import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '../lib/auth/useAuth';
import { useAccount } from '../lib/account/useAccount';
import { prefetchRouteData } from '../lib/route-data';

/** Returns a function that starts the data reads for a sidebar destination (`lib/route-data.ts`). */
export function usePrefetchRouteData(): (path: string) => void {
  const queryClient = useQueryClient();
  const { accountId } = useAuth();
  const { account, administeredBy, isLoading } = useAccount();
  const practiceType = account?.practiceSettings?.practiceType;
  const administered = administeredBy !== null;
  return useCallback((path: string) => {
    if (!accountId) return;
    prefetchRouteData(path, { queryClient, accountId, account: { practiceType, administered, isLoading } });
  }, [queryClient, accountId, practiceType, administered, isLoading]);
}
